import React from 'react';
import numeral from "numeral";
import * as d3 from '../../libraries/d3';

export default class RightYAxis extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    };
  };

  componentDidMount() {
    var controlTicks = this.props.controlTicks
    var YAxisGenerator = d3.axisRight()
      .scale(this.props.yScale);

    var yAxis = this.props.bounds().append('g')
      .call(controlTicks
        ?
        YAxisGenerator
          .tickFormat(d => this.props.dataType === 'currency' ? this.formatCurrency(d) : this.props.dataType === 'percent' ? `${d}%` : d)
          .ticks(10)
        :
        YAxisGenerator
          .tickFormat(d => this.props.dataType === 'currency' ? this.formatCurrency(d) : this.props.dataType === 'percent' ? `${d}%` : d)
      )
      .attr('class', `right-y-axis-${this.props.report_details.id}`)
      .attr("transform", `translate(${this.props.dimensions().boundedWidth},0)`)

    var yAxisLabel = yAxis.append('text')
      .attr('x', -this.props.dimensions().boundedHeight / 2)
      .attr('y', -this.props.dimensions().margin.left + 120)
      .attr('fill', 'black')
      .style('font-size', '1.4em')
      .text(`${this.props.report_details.second_y_label}`)
      .style('transform', 'rotate(-90deg)')
      .style('text-anchor', 'middle')
  };

  componentDidUpdate(prevProps) {
    let yScale = this.props.dataType == 'percent' ? d3.scaleLinear().domain([0, 100]).nice().range([this.props.dimensions().boundedHeight, 0]) : d3.scaleLinear().domain([this.props.yMaxMinDetailndValue.min, this.props.yMaxMinDetailndValue.max]).nice().range([this.props.dimensions().boundedHeight, 0]);
    let controlTicks = this.props.controlTicks

    let YAxisGenerator = d3.axisRight()
      .scale(yScale);

    let t = d3.transition()
      .duration(750);

    let yAxis = d3.select(`.right-y-axis-${this.props.report_details.id}`)
      .transition(t)
      .call(controlTicks
        ?
        YAxisGenerator
          .tickFormat(d => this.props.dataType === 'currency' ? this.formatCurrency(d) : this.props.dataType === 'percent' ? `${d}%` : d)
          .ticks(10)
        :
        YAxisGenerator
          .tickFormat(d => this.props.dataType === 'currency' ? this.formatCurrency(d) : this.props.dataType === 'percent' ? `${d}%` : d)
        );
  };

  render() {
    return (
      null
    );
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

};